import React from 'react';

import Button from 'components/form/Button.component';
import { useTranslation } from 'providers/GILT.provider';

import DropdownMenuFooter from 'clientCommunications/components/Clients/common/DropdownMenuFooter.component';

const AllStylistDropDown = ({ stylists, selectedStylistIds, isStylistOpen, onFilterStylist, closeStylistDropDown, onSelectStylist, onSelectAllStylists }) => {
  const { t } = useTranslation();

  const onDone = () => {
    onFilterStylist(selectedStylistIds);
    closeStylistDropDown();
  };

  const allSelected = stylists.length === selectedStylistIds.length;

  const activeStylists = stylists?.filter((c) => c.status === 'active' && c.has_column);
  const inactiveStylists = stylists?.filter((c) => c.status !== 'active');

  // TODO: update css classes
  return (
    <div data-bem="AllStylistDropDown" className={`drop-down dd-stylist ${isStylistOpen ? '' : 'hidden'} `}>
      <div className="main">
        <div>
          <span className="span-header">{t('allClients.allStylistDropdown.title')}</span>
          <ul>
            {activeStylists.map((stylist) => (
              <li key={stylist.id} className="dropdown-item">
                <label className="clickable-label">
                  <span>{stylist.user_name}</span>
                  <div className="checkbox-box-custom-wrap dd-chk">
                    <input
                      type="checkbox"
                      className="checkbox-box-custom"
                      id={`clients-check-${stylist.id}`}
                      checked={selectedStylistIds && selectedStylistIds.filter((c) => c === stylist.id).length > 0}
                      onChange={() => onSelectStylist(stylist.id)}
                    />
                    <label className="checkbox-box-label" htmlFor={`clients-check-${stylist.id}`}>
                      <div className="checkbox-box-custom-icon">
                        <span className="ic-sml-18px ic_check_white_18" />
                      </div>
                    </label>
                  </div>
                </label>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <span className="span-header">{t('allClients.allStylistDropdown.previousStaff')}</span>
          <ul>
            {inactiveStylists.map((stylist) => (
              <li key={stylist.id} className="dropdown-item">
                <label className="clickable-label">
                  <span>{stylist.user_name}</span>

                  <div className="checkbox-box-custom-wrap dd-chk">
                    <input
                      type="checkbox"
                      className="checkbox-box-custom"
                      id={`clients-check-${stylist.id}`}
                      checked={selectedStylistIds && selectedStylistIds.filter((c) => c === stylist.id).length > 0}
                      onChange={() => onSelectStylist(stylist.id)}
                    />
                    <label className="checkbox-box-label" htmlFor={`clients-check-${stylist.id}`}>
                      <div className="checkbox-box-custom-icon">
                        <span className="ic-sml-18px ic_check_white_18" />
                      </div>
                    </label>
                  </div>
                </label>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <DropdownMenuFooter>
        <Button variant="slim" onClick={() => onSelectAllStylists(!allSelected)}>
          {allSelected ? t('common.buttons.clearAllUpp') : t('common.buttons.selectAllUpp')}
        </Button>
        <Button variant="slim" onClick={onDone}>
          {t('common.buttons.doneUpp')}
        </Button>
      </DropdownMenuFooter>
    </div>
  );
};

export default AllStylistDropDown;
